<template>
  <div class="auth-wrapper auth-v1 px-2">
    <div class="auth-inner py-2">

      <!-- Login v1 -->
      <b-card class="mb-0">
        <b-link class="brand-logo">
           <b-img
            fluid
            :src="imgUrl"
            alt="Login V2"
            width="100"
          />
        </b-link>

        <b-card-title class="mb-4" style="text-align: center;">
          Ujian Online
        </b-card-title>
        <p>Halaman akan pindah otomatis ke dashboard dalam 3 detik ...</p>
      </b-card>
      <!-- /Login v1 -->
    </div>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BButton, BForm, BFormInput, BFormGroup, BCard, BLink, BCardTitle, BCardText, BInputGroup, BInputGroupAppend, BFormCheckbox, BImg, BSpinner,
} from 'bootstrap-vue'
import VuexyLogo from '@core/layouts/components/Logo.vue'
import { required, email } from '@validations'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'
import store from '@/store/index'
import router from '@/router'
import vSelect from 'vue-select'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import {
  Authlogin,
  setToken,
  setRefreshToken,
} from '@/connection-api/authentication'
import {
  resetAkun,
  getTokenSso,
} from '@/connection-api/master'

export default {
  components: {
    // BSV
    BButton,
    BForm,
    BFormInput,
    BFormGroup,
    BCard,
    BCardTitle,
    BLink,
    VuexyLogo,
    BCardText,
    BInputGroup,
    BInputGroupAppend,
    BFormCheckbox,
    ValidationProvider,
    ValidationObserver,
    BImg,
    vSelect,
    BSpinner,
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      loading: 0,
      loadingShow: false,
      reset: {},
      username: '',
      password: '',
      status: '',
      login_sebagai: null,
      // validation rules
      required,
      email,
      sideImg: require('@/assets/images/logo/logo.png'),
      loginSebagaiOption: {
        selected: 'id',
        options: [
          { value: null, title: '--Pilih Login Sebagai --' },
          { value: 'mahasiswa', title: 'Mahasiswa' },
          { value: 'penguji', title: 'Penguji' },
          { value: 'pembimbing', title: 'Pembimbing' },
          
        ],
      },
    }
  },
  async mounted() {
    if(this.$route.query.token) {
      localStorage.removeItem('accessToken');
      localStorage.removeItem('userData');

      const response = await getTokenSso(this.$route.query.token)
      if(response.data.success == true)
      {
        // 1. Store array_data['data']['accessToken'] in localStorage named accessToken
        localStorage.setItem('accessToken', response.data.data.accessToken);
        // 2. Store array_data['data']['member'] in localStorage named userData
        localStorage.setItem('userData', JSON.stringify(response.data.data.userData));

        localStorage.setItem('loginMethod', 'sso');

        const userData = response.data.data.userData
        if (userData.email && userData.email.includes('portal-psikoui.com')) {
          // Email contains 'portal-psikoui.com', perform actions here
          // For example, you can redirect or execute some code
          setTimeout(() => {
            window.location.href = `https://ujian.portal-psikoui.com/account/reset/${response.data.data.tokenVerification}`
          }, 2000);
        } else {
          setTimeout(() => {
            window.location.href = 'https://ujian.portal-psikoui.com/dashboard/analytics'
          }, 2000);
        }

      } else {
        alert('Login gagal, silahkan login kembali menggunakan SSO')
        window.location.href = 'https://ujian.portal-psikoui.com/login'
      }
    }

    
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
    imgUrl() {
      if (store.state.appConfig.layout.skin === 'dark') {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.sideImg = require('@/assets/images/logo/logo.png')
        return this.sideImg
      }
      return this.sideImg
    },
  },
  methods: {
    simpanResetAkun()
    {
      this.loadingShow = true
      resetAkun(this.reset)
      .then(response => {
      if (response.data.success == true) {
        this.loadingShow = false
       this.$toast({
          component: ToastificationContent,
          position: 'top-right',
          props: {
            title: `Reset Akun`,
            icon: 'CoffeeIcon',
            variant: 'success',
            text: 'Anda telah berhasil reset akun Ujian Online. Silahkan login menggunakan kredensial baru anda.',
          },
        })
        this.$bvModal.hide('bv-modal-reset-user')
      } else {
        this.loadingShow = false
        this.$toast({
          component: ToastificationContent,
          position: 'top-right',
          props: {
            title: `Reset Akun`,
            icon: 'CoffeeIcon',
            variant: 'danger',
            text: response.data.message,
          },
        })
        // this.$bvModal.hide('bv-modal-reset-user')
      }
      })
      .catch(error => console.log(error));
    },
    login() {
      this.loading = 1
      this.$refs.loginForm.validate().then(success => {
        if (success) {
          Authlogin({
            email: this.username,
            password: this.password,
            application_token: this.applicationToken,
            query: router.currentRoute.query,
            token_firebase: localStorage.getItem('tokenFirebase'),
            login_sebagai: this.login_sebagai,
          })
            .then(response => {
              if (response.data.error) {
                this.loading = 0
                this.$swal({
                  title: 'Gagal!',
                  html: `${response.data.message}`,
                  icon: 'error',
                  customClass: {
                    confirmButton: 'btn btn-primary',
                  },
                  buttonsStyling: false,
                })
              } else {
                this.loading = 0
                if(response.data.reset == true)
                {
                  this.$bvModal.show('bv-modal-reset-user')
                  this.reset.token = response.data.token
                }

                const { member, urlCallback } = response.data.data
                setToken(response.data.data.accessToken)
                setRefreshToken(response.data.data.refreshToken)

                /// /////// TEMPORARY ACL SIMULATION ////////////////

                // baca value userData.roles
                // value-nya mungkin bisa  array of string atau hanya string
                // jadi perlu check if array
                // let userRole = ''
                // if (Array.isArray(member.roles)) {
                //   // ambil item pertama
                //   const test = member.roles[0]
                //   userRole = test
                // } else {
                //   userRole = member.roles
                // }

                localStorage.setItem('userData', JSON.stringify(member))
                this.$ability.update(member.ability)
                if (urlCallback === '') {
                  this.$router.push('/dashboard/analytics')
                    .then(() => {
                      this.$toast({
                        component: ToastificationContent,
                        position: 'top-right',
                        props: {
                          title: `Selamat Datang ${member.fullName || member.username}`,
                          icon: 'CoffeeIcon',
                          variant: 'success',
                          text: 'Anda telah berhasil masuk Ujian Online. Sekarang Anda bisa mulai menjelajah!',
                        },
                      })
                    })
                } else {
                  localStorage.setItem('urlCallback', urlCallback)
                  window.location.href = urlCallback
                }
              }
            })
        }
      })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';
</style>
